import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppComponent } from '../app/app.component';

@Injectable()
export class ServicesService {
  constructor(private http: HttpClient, private _appcomponent: AppComponent) {}

  /**
   * Valida o usuário e recebe o Token de Autenticacao
   */
  public getToken(userData: any): Promise<any> {
    const urlApi = this._appcomponent.ApiUrl + 'getToken';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .post<any>(urlApi, userData, { headers })
      .toPromise()
      .then(this.requestSuccess)
      .catch(err => this.handleError(err));
  }

  /**
   * Valida se o token é válido
   */
  public checkToken(tokenData: any): Observable<any> {
    const urlApi = this._appcomponent.ApiUrl + 'checkToken';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<any>(urlApi, tokenData, { headers }).pipe(
      map(data => this.requestSuccess(data)),
      catchError(err => this.handleError(err))
    );
  }

  public listAPIData(operation: string, query: string = null): Promise<any> {
    const urlApi = this._appcomponent.ApiUrl + operation;
    const SessionInfo: any = this.getLocalStorage('plataformaWeb');

    const body = {
      tokenId: SessionInfo.token,
      secret: SessionInfo.secret,
      query: query
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .post<any>(urlApi, body, { headers })
      .toPromise()
      .then(this.requestSuccess)
      .catch(err => this.handleError(err));
  }

  public requestAPIData(dados: any, operation: string): Promise<any> {
    const urlApi = this._appcomponent.ApiUrl + operation;
    const SessionInfo: any = this.getLocalStorage('plataformaWeb');

    const tbody = new Body();
    tbody.tokenId = SessionInfo.token;
    tbody.secret = SessionInfo.secret;
    tbody.dados = dados;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .post<any>(urlApi, tbody, { headers })
      .toPromise()
      .then(this.requestSuccess)
      .catch(err => this.handleError(err));
  }

  private requestSuccess(res: any) {
    // HttpClient já retorna JSON
    return res || {};
  }

  private handleError(error: any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

  public verifyMandatoryFields(
    serializedArray: any,
    mandatoryFields: string[]
  ) {
    let i: number;
    const r: any = { status: true };
    for (i = 0; i < mandatoryFields.length; i++) {
      if (
        serializedArray[mandatoryFields[i]] === undefined ||
        serializedArray[mandatoryFields[i]].length <= 0
      ) {
        r['status'] = false;
        r['field'] = mandatoryFields[i];
        break;
      }
    }
    return r;
  }

  waitButton(btSelector: string, strTexto: string = 'Aguarde...') {
    $(btSelector).html(strTexto);
    $(btSelector).addClass('disabled');
    $(btSelector).attr('disabled', 'true');
    return true;
  }

  returnButton(btSelector: string, strTexto: string) {
    $(btSelector).html(strTexto);
    $(btSelector).removeClass('disabled');
    $(btSelector).removeAttr('disabled');
    return true;
  }

  arraytoObj(arr: any, returnStr: boolean = false) {
    const nObj: any = {};
    for (let i = 0; i < arr.length; i++) {
      nObj[arr[i]['name']] = arr[i]['value'];
    }
    return returnStr ? JSON.stringify(nObj) : nObj;
  }

  setLocalStorage(var_name: string, value: string, expire: number = 43200000) {
    if (typeof Storage !== 'undefined') {
      const record = { value: value, timestamp: new Date().getTime() + expire };
      localStorage.setItem(var_name, JSON.stringify(record));
      return true;
    } else {
      return false;
    }
  }

  getLocalStorage(var_name: string) {
    let record: any = localStorage[var_name];
    if (!record) {
      return false;
    } else {
      record = JSON.parse(record);
      if (new Date().getTime() <= record.timestamp) {
        return record.value;
      } else {
        localStorage.removeItem(var_name);
        return false;
      }
    }
  }

  delLocalStorage(var_name: string) {
    if (typeof Storage !== 'undefined') {
      localStorage.removeItem(var_name);
      return true;
    } else {
      return false;
    }
  }

  ucname(words: string) {
    words = words.trim();
    let arrwords: string[] = words.toLowerCase().split(' ');
    for (let a = 0; a < arrwords.length; a++) {
      const w = arrwords[a];
      arrwords[a] = w[0].toUpperCase() + w.slice(1);
    }
    return arrwords
      .join(' ')
      .replace(/\bA\b/g, 'a')
      .replace(/\bE\b/g, 'e')
      .replace(/\bO\b/g, 'o')
      .replace(/\bDa\b/g, 'da')
      .replace(/\bDe\b/g, 'de')
      .replace(/\bDo\b/g, 'do')
      .replace(/\bDas\b/g, 'das')
      .replace(/\bDos\b/g, 'dos');
  }
}

export class Body {
  tokenId: string;
  secret: string;
  dados: any;
}
